"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames7 = _interopRequireDefault(require("classnames"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right2"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left12"));
var _arrowLeft2 = _interopRequireDefault(require("cccisd-icons/arrow-left8"));
var _lock = _interopRequireDefault(require("cccisd-icons/svg/lock4"));
var _circle = _interopRequireDefault(require("cccisd-icons/circle"));
var _circle2 = _interopRequireDefault(require("cccisd-icons/circle2"));
var _arrowRight2 = _interopRequireDefault(require("cccisd-icons/arrow-right8"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdSideMenu = _interopRequireDefault(require("cccisd-side-menu"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdColorPicker = require("cccisd-color-picker");
var _useWithModulesMediator = _interopRequireDefault(require("./useWithModulesMediator"));
var _Settings = require("../Settings");
var _LessonCard = _interopRequireDefault(require("./components/LessonCard"));
var _style = _interopRequireDefault(require("./style.css"));
var _style2 = _interopRequireDefault(require("../../courseWrapper/Mediator/style.css"));
var _useOverlayBgStyles = _interopRequireDefault(require("../../courseWrapper/Mediator/useOverlayBgStyles"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _aspectRatioOptions = _interopRequireDefault(require("../Settings/aspectRatioOptions.js"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var translate = {
  en: {
    lessonText: 'LESSON',
    moduleOptional: 'indicates optional content',
    moduleRequired: 'indicates required content',
    moduleText: 'MODULE',
    nextModule: 'Next Module',
    overview: 'Overview',
    previousModule: 'Previous Module'
  },
  es: {
    lessonText: 'LECCIÓN',
    moduleOptional: 'indica contenido opcional',
    moduleRequired: 'indica contenido requerido',
    moduleText: 'MÓDULO',
    nextModule: 'Módulo Próximo',
    overview: 'El Resumen',
    previousModule: 'Módulo Anterior'
  }
};
var screenSm = Number(_style["default"].screenSm.replace('px', ''));
var NestedContextProvider = function NestedContextProvider(_ref) {
  var context = _ref.context,
    value = _ref.value,
    children = _ref.children;
  var prevValue = (0, _react.useContext)(context);
  var mergedValue = _objectSpread(_objectSpread({}, prevValue), value);
  var Provider = context.Provider;
  return /*#__PURE__*/_react["default"].createElement(Provider, {
    value: mergedValue
  }, children);
};
var WithModulesMediator = function WithModulesMediator(props) {
  var mediatorProps = props.mediatorProps,
    _props$courseWrapperM = props.courseWrapperMediatorProps,
    courseWrapperMediatorProps = _props$courseWrapperM === void 0 ? {} : _props$courseWrapperM,
    isNetworkError = props.isNetworkError,
    onPlayerShow = props.onPlayerShow,
    onPlayerHide = props.onPlayerHide;
  var overlayBgStyles = (0, _useOverlayBgStyles["default"])(courseWrapperMediatorProps.currentLayout, courseWrapperMediatorProps.setIsShowingLayoutBgColor);
  var _useState = (0, _react.useState)(window.innerWidth < screenSm),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    modalSize = _useState4[0],
    setModalSize = _useState4[1];
  var language = Object.keys(translate).includes(props.language) ? props.language : 'en';
  var settings = _objectSpread(_objectSpread({}, _Settings.initialValues), mediatorProps);
  var mustTakeInOrder = settings.mustTakeInOrder,
    showLastVisited = settings.showLastVisited,
    showLessonNum = settings.showLessonNum,
    showProgressBubbleNum = settings.showProgressBubbleNum,
    showLessonsInModal = settings.showLessonsInModal,
    highlighting = settings.highlighting,
    requiredHighlightColor = settings.requiredHighlightColor,
    optionalHighlightColor = settings.optionalHighlightColor,
    baseColor = settings.baseColor,
    buttonColors = settings.buttonColors,
    progressBubbleColors = settings.progressBubbleColors;
  var _useWithModulesMediat = (0, _useWithModulesMediator["default"])(_objectSpread(_objectSpread({}, props), {}, {
      mustTakeInOrder: mustTakeInOrder
    })),
    closeFlowPlayer = _useWithModulesMediat.closeFlowPlayer,
    currentFlowProps = _useWithModulesMediat.currentFlowProps,
    modules = _useWithModulesMediat.modules,
    isLoading = _useWithModulesMediat.isLoading;
  var currentModule = modules.length === 1 && modules[0].lessons ? modules[0] : modules.find(function (m) {
    return m.isActive;
  });
  var currentModuleIndex = modules.indexOf(currentModule);
  var baseColorHex = (0, _cccisdColorPicker.getColor)(baseColor);
  var isOneModule = modules.length <= 1;
  var isHideHeader = isOneModule && currentModule && !('title' in currentModule) && !('header' in currentModule);
  var forceAspectRatio = Boolean(mediatorProps.showLessonsInModal && mediatorProps.aspectRatio);
  var modalRef = (0, _react.useRef)();
  var modalBgRef = (0, _react.useRef)();
  var flowRef = (0, _react.useRef)();
  var prevSize = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (modalRef && modalRef.current) modalRef.current.open();
  }, [modalRef.current, currentFlowProps]);
  (0, _react.useEffect)(function () {
    function checkScreenWidth() {
      setIsMobile(window.innerWidth < screenSm);
    }
    window.addEventListener('resize', checkScreenWidth);
    return function () {
      return window.removeEventListener('resize', checkScreenWidth);
    };
  }, [isMobile]);
  var handleWindowResize = (0, _react.useCallback)((0, _debounce2["default"])(function () {
    var _prevSize$current, _prevSize$current2;
    if (!forceAspectRatio) {
      return;
    }
    var flowArea = flowRef.current;
    var contentArea = document.getElementById('cccisd-flow-content-area');
    if (!contentArea || !flowArea) {
      return;
    }
    var aspectRatio = function () {
      var option = _aspectRatioOptions["default"].find(function (item) {
        return item.value === mediatorProps.aspectRatio;
      });
      return option ? option.aspectRatio : null;
    }();
    if (!aspectRatio) {
      return;
    }
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var flowRect = flowArea.getBoundingClientRect();
    var contentRect = contentArea.getBoundingClientRect();
    var extraHeight = flowRect.height - contentRect.height;
    var extraWidth = flowRect.width - contentRect.width;
    var windowPadding = 16;
    var mobileNavHeight = 36;
    var availableHeight = windowHeight - windowPadding * 2 - mobileNavHeight - extraHeight;
    var availableWidth = windowWidth - windowPadding * 2 - extraWidth;
    var contentWidth = Math.min(availableWidth, availableHeight * aspectRatio);
    var contentHeight = contentWidth / aspectRatio + 1; // +1 just to fix rounding issues

    var width = contentWidth + extraWidth;
    var height = contentHeight + extraHeight + mobileNavHeight;
    if (width !== ((_prevSize$current = prevSize.current) === null || _prevSize$current === void 0 ? void 0 : _prevSize$current.width) || height !== ((_prevSize$current2 = prevSize.current) === null || _prevSize$current2 === void 0 ? void 0 : _prevSize$current2.height)) {
      // changing the flow content height using css variable
      document.documentElement.style.setProperty('--cccisd-flow-content-area-height', contentHeight + 'px');
      prevSize.current = {
        width: width,
        height: height
      };
      setModalSize({
        width: width,
        height: height
      });
    }
  }, 100), []);
  (0, _react.useEffect)(function () {
    if (!currentFlowProps || !forceAspectRatio) {
      return;
    }
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [currentFlowProps, forceAspectRatio]);
  (0, _react.useEffect)(function () {
    if (!currentFlowProps || !forceAspectRatio) {
      return;
    }
    if (modalBgRef.current) {
      var observer = new MutationObserver(handleWindowResize);
      observer.observe(modalBgRef.current, {
        childList: true,
        subtree: true
      });
      return function () {
        return observer.disconnect();
      };
    }
  }, [currentFlowProps, forceAspectRatio]);
  (0, _react.useEffect)(function () {
    if (currentFlowProps && onPlayerShow) {
      onPlayerShow({
        currentFlowProps: currentFlowProps
      });
    } else if (!currentFlowProps && onPlayerHide) {
      onPlayerHide();
    }
  }, [currentFlowProps]);
  function getHighlightColor() {
    switch (highlighting) {
      case '':
        return '';
      case 'required':
        return requiredHighlightColor in _style["default"] ? _style["default"][requiredHighlightColor] : requiredHighlightColor;
      case 'optional':
        return optionalHighlightColor in _style["default"] ? _style["default"][optionalHighlightColor] : optionalHighlightColor;
      default:
        console.error("Setting value '".concat(highlighting, "' is not a valid option for highlighting."));
        return '';
    }
  }
  function renderPlayerView() {
    if (!currentFlowProps) {
      return null;
    }
    var renderBreadcrumbs = function renderBreadcrumbs(_ref2) {
      var inModal = _ref2.inModal;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].breadcrumbsWrapper,
        style: {
          marginBottom: inModal ? '0px' : '7px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].breadcrumbs
      }, currentModule.title ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentModule.title, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "\xA0\xA0") : null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: currentFlowProps.title
      })), !courseWrapperMediatorProps.renderCourseInOverlay && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: _style["default"].closeButton,
        onClick: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
    };
    var playerView = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].flow,
      ref: flowRef
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
      key: currentFlowProps.handle
    }, currentFlowProps, {
      isNetworkError: isNetworkError
    })));
    if (courseWrapperMediatorProps.renderCourseInOverlay) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        bodyStyle: overlayBgStyles.style,
        ref: modalRef,
        modalClassName: _style2["default"].courseWrapperInOverlayModal,
        title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            gap: '1em',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: courseWrapperMediatorProps.modalHeaderImageUrl ? "<img src=\"".concat(courseWrapperMediatorProps.modalHeaderImageUrl, "\" alt=\"").concat(courseWrapperMediatorProps.modalHeaderImageFileName, "\" height=\"36\" data-image=\"980\" />") : ''
        }), renderBreadcrumbs({
          inModal: true
        }))),
        afterClose: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].flow,
        "data-cccisd-survey-area": true
      }, playerView));
    }
    var playerContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile || showLessonsInModal ? renderModuleNav() : renderBreadcrumbs({
      inModal: false
    }), playerView);
    var isAspectRatio = Boolean(forceAspectRatio && modalSize);
    return showLessonsInModal ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])(_style["default"].playerViewModal, isAspectRatio && _style["default"].withAspectRatio),
      "data-cccisd-survey-area": true,
      ref: modalBgRef
    }, /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: (0, _classnames7["default"])(!isAspectRatio && _style["default"].sizeBox, forceAspectRatio && !isAspectRatio && _style["default"].hidden)
    }, isAspectRatio ? {
      style: {
        width: modalSize.width + 'px',
        height: modalSize.height + 'px'
      },
      'data-cccisd-survey-area': true
    } : {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].playerContent
    }, playerContent))) : playerContent;
  }
  function renderModuleView() {
    if (currentFlowProps || !currentModule) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: isMobile ? 'block' : 'flex'
      }
    }, renderModuleNav(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].content
    }, renderHeader(), renderLessonArea()));
  }
  function renderModuleNav() {
    if (isOneModule && !currentFlowProps) {
      return null;
    }
    if (isMobile || showLessonsInModal && currentFlowProps) {
      var renderCollapseNav = function renderCollapseNav(closeNavigation) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: 'btn btn-default ' + _style["default"].closeButton,
          onClick: closeNavigation,
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null));
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mobileNav
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSideMenu["default"], {
        renderCloseButton: function renderCloseButton(_ref3) {
          var closeNavigation = _ref3.closeNavigation;
          return currentFlowProps ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].mobileNavCloseButton
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames7["default"])(_defineProperty({}, _style["default"].mobileNavCloseButtonActiveLesson, !isHideHeader))
          }, renderCollapseNav(closeNavigation)), !isHideHeader && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
            className: _style["default"].moduleHeaderInMenu,
            style: {
              color: "".concat(baseColorHex)
            }
          }, getModuleHeaderText(currentModule)), /*#__PURE__*/_react["default"].createElement("p", {
            className: _style["default"].moduleTitleInMenu
          }, currentModule.title))) : /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].mobileNavCloseButton
          }, renderCollapseNav(closeNavigation));
        },
        renderTabs: function renderTabs(_ref4) {
          var closeNavigation = _ref4.closeNavigation;
          return currentFlowProps ? /*#__PURE__*/_react["default"].createElement("ul", {
            className: _style["default"].mobileNavLessonMenu
          }, currentModule.lessons.map(function (les, i) {
            var _classnames2;
            return /*#__PURE__*/_react["default"].createElement("li", {
              onClick: function onClick() {
                if (!les.isAllowed) {
                  return;
                }
                les.setCurrent();
                closeNavigation();
              },
              key: les.title + i,
              className: (0, _classnames7["default"])((_classnames2 = {}, _defineProperty(_classnames2, _style["default"].locked, !les.isAllowed), _defineProperty(_classnames2, _style["default"].complete, les.isCompleted && les.isAllowed), _defineProperty(_classnames2, _style["default"].active, currentFlowProps.flowId === les.flowId), _classnames2))
            }, /*#__PURE__*/_react["default"].createElement("span", null, (showLessonNum || !!getLessonHighlight(les)) && /*#__PURE__*/_react["default"].createElement("p", {
              className: _style["default"].lessonText,
              style: {
                color: "".concat(baseColorHex)
              }
            }, getLessonHighlight(les), showLessonNum && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(translate[language].lessonText, " ").concat(i + 1))), /*#__PURE__*/_react["default"].createElement("span", null, typeof les.title === 'string' ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: les.title
            }) : /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: les.title.content
            }))), !les.isAllowed && /*#__PURE__*/_react["default"].createElement("span", {
              className: _style["default"].icon
            }, /*#__PURE__*/_react["default"].createElement(_lock["default"], null)), les.isCompleted && /*#__PURE__*/_react["default"].createElement("span", {
              className: _style["default"].icon
            }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
          }), currentModule.lessons.some(function (lesson) {
            return highlighting === 'required' && lesson.isRequired || highlighting === 'options' && !lesson.isRequired;
          }) && /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(_style["default"].menuHighlightKey, " ").concat(_style["default"].mobile)
          }, renderHighlightKey())) : /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(_style["default"].sidebar, " ").concat(_style["default"].mobile)
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].moduleNav
          }, renderModulesList(closeNavigation)));
        },
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-default",
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))
      }), currentFlowProps && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-xs btn-default",
        type: "button",
        onClick: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sidebar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].moduleNav
    }, renderModulesList()));
  }
  function renderModulesList() {
    var closeNavigation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var isAnyModuleHighlighted = highlighting === 'optional' && modules.some(function (m) {
      return m.lessons.every(function (les) {
        return !les.isRequired;
      });
    }) || highlighting === 'required' && modules.some(function (m) {
      return m.lessons.some(function (les) {
        return les.isRequired;
      });
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, modules.map(function (module) {
      var _classnames3;
      var handleClick = function handleClick() {
        if (module.lessons.length > 0 && module.isAllowed) {
          module.setActive();
          closeNavigation();
        }
      };
      var isHighlighted;
      switch (highlighting) {
        case 'required':
          isHighlighted = module.lessons.some(function (les) {
            return les.isRequired;
          });
          break;
        case 'optional':
          isHighlighted = module.lessons.every(function (les) {
            return !les.isRequired;
          });
          break;
        default:
        // leave undefined
      }

      if (module.isEmpty) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: module.id,
        className: (0, _classnames7["default"])(_style["default"].item, (_classnames3 = {}, _defineProperty(_classnames3, _style["default"].allowed, module.isAllowed), _defineProperty(_classnames3, _style["default"].current, module.isActive), _defineProperty(_classnames3, _style["default"].notStarted, module.showDimmed), _defineProperty(_classnames3, _style["default"].beforeActive, modules.indexOf(module) === currentModuleIndex - 1), _defineProperty(_classnames3, _style["default"].extraPad, isAnyModuleHighlighted), _classnames3)),
        style: module.isActive && baseColor ? {
          borderBottom: "1px solid ".concat(baseColorHex),
          borderLeft: "0.7rem solid ".concat(baseColorHex),
          borderTop: "1px solid ".concat(baseColorHex)
        } : {},
        onClick: handleClick
      }, isHighlighted && /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames7["default"])(_style["default"].moduleIcon, _style["default"].highlightIcon),
        style: {
          color: getHighlightColor()
        }
      }, highlighting === 'required' ? /*#__PURE__*/_react["default"].createElement(_circle2["default"], null) : /*#__PURE__*/_react["default"].createElement(_circle["default"], null)), /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].moduleHeader,
        style: module.showDimmed ? {} : {
          color: "".concat(baseColorHex)
        }
      }, getModuleHeaderText(module)), /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].moduleTitle
      }, module.title), module.isAllLessonsComplete && !module.showDimmed && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames7["default"])(_style["default"].moduleIcon, _style["default"].checkmark),
        style: {
          color: "".concat(baseColorHex)
        }
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), !module.isAllowed && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].moduleIcon
      }, /*#__PURE__*/_react["default"].createElement(_lock["default"], null)));
    }), isMobile && isAnyModuleHighlighted && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuHighlightKey
    }, renderHighlightKey()));
  }
  function renderHighlightKey() {
    return /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        color: getHighlightColor()
      }
    }, highlighting === 'required' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].highlightIcon
    }, /*#__PURE__*/_react["default"].createElement(_circle2["default"], null), "\xA0\xA0"), translate[language].moduleRequired) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].highlightIcon
    }, /*#__PURE__*/_react["default"].createElement(_circle["default"], null), "\xA0\xA0"), translate[language].moduleOptional));
  }
  function renderHeader() {
    var _classnames4;
    if (isHideHeader) {
      return null;
    }
    var highlightMessage;
    switch (highlighting) {
      case 'required':
        highlightMessage = currentModule.lessons.some(function (les) {
          return les.isRequired;
        }) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].headerHighlightKey
        }, renderHighlightKey());
        break;
      case 'optional':
        highlightMessage = currentModule.lessons.some(function (les) {
          return !les.isRequired;
        }) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].headerHighlightKey
        }, renderHighlightKey());
        break;
      default:
      // leave undefined
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])((_classnames4 = {}, _defineProperty(_classnames4, _style["default"].header, true), _defineProperty(_classnames4, _style["default"].oneModule, isOneModule), _defineProperty(_classnames4, _style["default"].isMobile, isMobile), _classnames4))
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headerModule,
      style: {
        color: "".concat(baseColorHex)
      }
    }, getModuleHeaderText(currentModule)), /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headerTitle
    }, currentModule.title)), highlightMessage);
  }
  function getModuleHeaderText(module) {
    return 'header' in module ? module.header : translate[language].moduleText + ' ' + module.id;
  }
  function renderOverview() {
    var _classnames5;
    if (!currentModule.overview) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])((_classnames5 = {}, _defineProperty(_classnames5, _style["default"].overview, true), _defineProperty(_classnames5, _style["default"].lessPadLeft, isOneModule || isMobile), _classnames5))
    }, /*#__PURE__*/_react["default"].createElement("h5", null, currentModule.overviewTitle || translate[language].overview), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].overviewContent
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentModule.overview
    })));
  }
  function getLessonHighlight(lesson) {
    var highlight;
    switch (highlighting) {
      case 'required':
        highlight = lesson.isRequired && /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: getHighlightColor()
          },
          className: _style["default"].highlightIcon
        }, /*#__PURE__*/_react["default"].createElement(_circle2["default"], null), "\xA0\xA0");
        break;
      case 'optional':
        highlight = !lesson.isRequired && /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: getHighlightColor()
          },
          className: _style["default"].highlightIcon
        }, /*#__PURE__*/_react["default"].createElement(_circle["default"], null), "\xA0\xA0");
        break;
      default:
      // leave undefined
    }

    return highlight;
  }
  function renderLessonArea() {
    var _classnames6;
    var isNextModuleButtonsVisible = false;
    var previousModuleLink = /*#__PURE__*/_react["default"].createElement("span", null);
    if (isMobile && Number.isInteger(currentModuleIndex) && currentModuleIndex >= 1) {
      var prevModule = modules[currentModuleIndex - 1];
      if (prevModule.isAllowed && !prevModule.isEmpty && prevModule.lessons.length > 0) {
        isNextModuleButtonsVisible = true;
        previousModuleLink = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-link text-right",
          type: "button",
          onClick: prevModule.setActive
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].arrow
        }, /*#__PURE__*/_react["default"].createElement(_arrowLeft2["default"], {
          spaceRight: true
        })), /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].label
        }, translate[language].previousModule, ": "), /*#__PURE__*/_react["default"].createElement("span", null, prevModule.title || getModuleHeaderText(prevModule))));
      }
    }
    var nextModuleLink = /*#__PURE__*/_react["default"].createElement("span", null);
    if (isMobile && Number.isInteger(currentModuleIndex) && currentModuleIndex >= 0 && currentModuleIndex + 1 < modules.length) {
      var nextModule = modules[currentModuleIndex + 1];
      if (nextModule.isAllowed && !nextModule.isEmpty && nextModule.lessons.length > 0) {
        isNextModuleButtonsVisible = true;
        nextModuleLink = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-link text-left",
          type: "button",
          onClick: nextModule.setActive
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].label
        }, translate[language].nextModule, ": "), /*#__PURE__*/_react["default"].createElement("span", null, nextModule.title || getModuleHeaderText(nextModule)), /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].arrow
        }, /*#__PURE__*/_react["default"].createElement(_arrowRight2["default"], {
          spaceLeft: true
        }))));
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])((_classnames6 = {}, _defineProperty(_classnames6, _style["default"].lessonWrapper, true), _defineProperty(_classnames6, _style["default"].lessMarginLeft, isOneModule || isMobile), _defineProperty(_classnames6, _style["default"].noMarginTop, isHideHeader && !('overview' in currentModule)), _classnames6))
    }, renderOverview(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonArea
    }, currentModule.lessons.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_LessonCard["default"], {
        baseColor: baseColor,
        buttonColors: buttonColors,
        getLessonHighlight: getLessonHighlight,
        key: index,
        item: item,
        language: language,
        lessonNum: index,
        lessons: currentModule.lessons,
        progressBubbleColors: progressBubbleColors,
        showLastVisited: showLastVisited,
        showLessonNum: showLessonNum,
        showProgressBubbleNum: showProgressBubbleNum
      });
    }), isNextModuleButtonsVisible && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].nextModuleButtons
    }, previousModuleLink, nextModuleLink)));
  }
  return /*#__PURE__*/_react["default"].createElement(NestedContextProvider, {
    context: _cccisdLaravelFlow.ForcedPlayerSettingsContext,
    value: _objectSpread({}, forceAspectRatio ? {
      showStickyBottomBar: false,
      adjustedPlayerWrapperStyle: {
        maxWidth: 'none',
        minHeight: 'none'
      }
    } : {})
  }, /*#__PURE__*/_react["default"].createElement(NestedContextProvider, {
    context: _cccisdLaravelFlow.DefaultPlayerSettingsContext,
    value: {
      background: 'solidColor',
      backgroundColor: '#fff',
      height: isMobile ? '' : '600px' // no min-height for phones, likely to have sticky-nav
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading,
    removeChildren: !isNetworkError
  }, renderPlayerView(), renderModuleView())));
};
var _default = WithModulesMediator;
exports["default"] = _default;